import React from "react";
import ProductSection from "./Components/ProductSection";
import { Plus } from "lucide-react";
import { TextField } from "@mui/material";
import SellasTable from "./Components/SellAsTable";
import "./styles/productStyles.css";

const SellasAddProduct = () => {
  return (
    <div className="overlow-y-scroll no-scrollbar my-16">
      <div className="flex flex-row mt-4 items-start justify-start gap-x-3 mx-[2.52222vw]">
        <TextField
          id="outlined-basic"
          label="PCS"
          variant="outlined"
          color="secondary"
          size="small"
        />
      </div>

      <ProductSection data={"Pack Info"} />
      <SellasTable />

      <button className="rounded-md px-9 py-[10px] text-[16px] font-medium font-outfit flex items-center justify-center flex-row bg-[#5652B0] mx-10 mt-10">
        {" "}
        <span className="px-2 text-white outfit-semibold">Add Pack</span>
      </button>
    </div>
  );
};

export default SellasAddProduct;
